var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarklogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 721.6 256.6",
    style: {
      enableBackground: "new 0 0 721.6 256.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill:#6AA163;}\r\n\t.st2{fill:#456ABB;}\r\n\t.st3{fill:#5B86E3;}\r\n\t.st4{fill:#EABD5A;}\r\n\t.st5{fill:#D57F2E;}\r\n\t.st6{fill:#ED9F39;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.6,256.6h48.3V114.5l-48.3-85.4V256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M721.6,256.6h-48.4V114.5l48.3-85.4v227.5H721.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M554.4,0.1h-57.8L610,181.8L721.6,0.2h-52.4l-58.4,92.5L554.4,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,253.1V3.6h97.9c18.9,0,35,3.3,48.4,10c13.4,6.7,23.6,16.1,30.7,28.3c7.1,12.2,10.6,26.5,10.6,43 c0,16.4-3.6,30.6-10.9,42.5c-7.3,11.9-17.7,21.1-31.3,27.5c-13.6,6.4-30,9.5-49.2,9.5h-65.8V123H355c10,0,18.4-1.5,25.1-4.4 c6.7-3,11.7-7.3,15.2-13c3.4-5.7,5.1-12.6,5.1-20.8c0-8.4-1.7-15.4-5.1-21.2c-3.4-5.7-8.5-10.2-15.2-13.2 c-6.7-3.1-15.1-4.6-25.3-4.6h-38.6v207.1H265V253.1z M404.5,253.1l-60-113.4h55.3L460.9,253h-56.4L404.5,253.1L404.5,253.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,173.6c-5-11.4-7.7-25.1-8.1-41.1H0c0.5,25.2,5.5,46.8,15.1,65c4.1,7.7,8.8,14.7,14.1,21l35-36.8 C62.7,179.2,61.3,176.5,60,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172.8,167.2c-1.2,6-3,11.4-5.6,16.3l34.3,36.1c4.7-5.6,8.8-11.6,12.2-18.1c5.6-10.7,9.2-22.2,10.8-34.3 H172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.9,185.8c-3.2,5.5-7.3,10.1-12.1,13.8c-0.1,0.1-0.2,0.2-0.3,0.3l30.8,35.9c2.4-1.8,4.8-3.7,7-5.7 c3.7-3.3,7.1-6.8,10.2-10.5l-34.3-36.1C166.8,184.2,166.4,185,165.9,185.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.2,181.7l-34.9,36.7c6.7,7.9,14.4,14.6,23,20.2L77,197.2C72.1,193,67.8,187.8,64.2,181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60,83.7c0.9-2.1,1.9-4.1,2.9-6L27.6,40.5c-4.6,5.7-8.7,11.9-12.3,18.7C5.2,78.3,0.1,101.3,0.1,128.3H52 C51.9,110.9,54.6,96,60,83.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M172.6,89.5h51.7c-1.9-14.1-5.9-26.6-12-37.7c-2.6-4.6-5.4-9-8.6-13L168.4,76 C170.4,80.1,171.8,84.6,172.6,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.9,128.5c0-0.1,0-0.1,0-0.2H0c0,0.1,0,0.1,0,0.2c0,1.4,0,2.7,0,4h51.9C51.9,131.2,51.9,129.8,51.9,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82,55.9L50.6,19.3c-8.7,5.9-16.4,12.9-23,21.2l35.3,37.2C67.8,68.6,74.2,61.3,82,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.9,70.9c1,1.6,1.8,3.3,2.6,5.1l35.3-37.2c-4.4-5.6-9.3-10.6-14.8-15.1c-3-2.4-6.2-4.7-9.5-6.8l-24.5,41 C159.3,61.6,163,65.9,165.9,70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M82.8,55.3c9.9-6.6,21.4-9.9,34.6-9.9c7.3,0,14,1,20.1,2.9c6.1,2,11.6,4.8,16.4,8.6c0.4,0.3,0.8,0.6,1.1,0.9 l24.5-41c-7.1-4.5-14.8-8.1-23.3-10.8c-12.3-4-25.6-6-39.9-6c-22,0-41.8,5.1-59.4,15.2c-2.2,1.3-4.3,2.6-6.4,4l31.4,36.6 C82.3,55.7,82.5,55.5,82.8,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.3,208.2c-6.1,2-12.8,3-19.9,3c-13.2,0-24.7-3.2-34.5-9.5c-2-1.3-4-2.8-5.8-4.4l-24.7,41.4 c1.4,0.9,2.9,1.8,4.4,2.7c17.6,10.2,37.5,15.2,59.7,15.2c15.5,0,29.6-2.3,42.1-7c9.5-3.6,18.1-8.2,25.8-13.8l-30.8-35.9 C148.7,203.4,143.3,206.2,137.3,208.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarklogo);
export default __webpack_public_path__ + "static/media/darklogo.739a07d56d9654cce0d66cc5c707511e.svg";
export { ForwardRef as ReactComponent };